<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="text-sm font-medium text-[var(--color-text-secondary)]">{{ label() }}</label>
  }
  <div class="flex flex-col gap-2">
    @for (option of options(); track option.value) {
      <label class="flex items-center gap-2 text-sm text-[var(--color-text-primary)] cursor-pointer">
        <input
          type="checkbox"
          class="w-5 h-5 accent-[var(--color-primary)] cursor-pointer rounded shrink-0"
          [checked]="isChecked(option.value)"
          (change)="onCheckboxChange(option.value, $any($event.target).checked)"
        />
        <span>{{ option.label }}</span>
      </label>
    }
  </div>
  @if (hasErrorState()) {
    <span class="text-xs text-[var(--color-text-error)]">{{ getErrorMessage() }}</span>
  }
</div>
